import * as types from '../constants/actionTypes';

export const setActiveForm = formType => ({
    type: types.SET_ACTIVE_FORM,
    payload: formType
});